// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Zfog","image":"Header_image__2otYe","name":"Header_name__22VTR","info":"Header_info__jKRT_","infoRow":"Header_infoRow__qQ8-b"};